import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "services-main-container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div id=\"services-header\"><div id=\"services-header-overlay\"></div><div id=\"services-header-text\" class=\"text-white\"><div class=\"services-title\"> Professional Development <br>and Consultative<br> Services </div><div class=\"services-header-blurb\"> CARE Behavioral Health provides a<br>wide-range of consultative and professional<br>development options to help your staff<br>gain the skills they need to do their best work. </div></div></div><div id=\"services-main-blurb\" class=\"text-blue\"> CARE Behavioral Health is a team of highly qualified personnel from a variety of disciplines that provide consultative services to school systems across the US. CARE BH&#39;s knowledge of public school systems coupled with in-depth knowledge and experience working with students and their families in the home and community-based settings allows them to focus on developing support systems for families and professionals who are striving to improve the overall quality of life for their children and students. </div>", 2)
const _hoisted_4 = {
  id: "services-main-testimonials-container",
  class: "flex j-evenly align-c mlr-auto text-blue"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { id: "testimonial-blurb" }, "What our clients are saying...", -1)
const _hoisted_6 = {
  id: "service-selection-container",
  class: "static-medium"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, "Professional Development", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, ">", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, "Consultative Services", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, ">", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReviewSlideShow = _resolveComponent("ReviewSlideShow")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_ReviewSlideShow)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_router_link, {
        to: "/services/professional-development",
        class: "services-selection-button button-link flex j-between align-c"
      }, {
        default: _withCtx(() => [
          _hoisted_7,
          _hoisted_8
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/services/consultations",
        class: "services-selection-button button-link flex j-between align-c"
      }, {
        default: _withCtx(() => [
          _hoisted_9,
          _hoisted_10
        ]),
        _: 1
      })
    ])
  ]))
}